import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import PageTemplate from './PageTemplate';

import LayoutWrap from "../Component/LayoutWrap";
import {
  LuArrowLeft, LuSendHorizonal, LuX, LuBold, LuItalic,
  LuUnderline, LuAlignLeft, LuAlignCenter, LuAlignRight,
  LuAlignJustify, LuMailOpen, LuPencil
} from 'react-icons/lu';
import { dashboardActions } from "../../../_actions";
import { GoMail } from "react-icons/go";
import { FaPlus } from "react-icons/fa6";


import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const isMobile = window.innerWidth <= 700;

class Replies extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();

    this.editorRef = createRef();

    this.state = {
      selectedMail: 0,
      selectedMailId: "",
      showMobileDetail: false,

      // NEW (Add/Edit Mail)
      showMailForm: false,
      isEdit: false,
      mailData: {
        id: "",
        senderName: "",
        senderEmail: "",
        senderDesignation: "",

        recipientName: "",
        recipientEmail: "",
        received: "",
        cc: "",

        subject: "",
        body: ""
      },
      showInboxIntro: true,
      showInboxIntroEdit: false,
      crrInboxIntro: ""
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getInsightMailReplies({}));
  }

  formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(Number(timestamp));
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    return `${day} ${month}`;
  };

  goToBack = () => {
    if (isMobile && this.state.showMobileDetail) {
      this.setState({ showMobileDetail: false });
    } else {
      window.history.back();
    }
  };

  handleSelect = (mail, i) => {
    if (mail === "intro") {
      this.setState({ showInboxIntro: true })
    } else {
      this.setState({ showInboxIntro: false })
      this.setState({
        selectedMail: i,
        selectedMailId: mail.id,
        showMobileDetail: true
      });
    }
  };

  // ➕ ADD MAIL
  handleAddMail = () => {
    this.setState({ showInboxIntro: false })
    this.setState({
      showMailForm: true,
      isEdit: false,
      mailData: {
        id: "",

        senderName: "",
        senderEmail: "",
        senderDesignation: "",

        recipientName: "",
        recipientEmail: "",
        received: "",
        cc: "",

        subject: "",
        body: ""
      }
    }, () => {
      if (this.editorRef.current) {
        this.editorRef.current.innerHTML = "<p></p>";
      }
    });
  };

  // ✏️ EDIT MAIL
  handleEditMail = (mail) => {
    this.setState({
      showMailForm: true,
      isEdit: true,
      mailData: {
        id: mail.id,

        senderName: mail.senderName,
        senderEmail: mail.senderEmail,
        senderDesignation: mail.senderDesignation,

        recipientName: mail.recipientName,
        recipientEmail: mail.recipientEmail,
        received: mail.received,
        cc: mail.cc,

        subject: mail.subject,
        body: mail.body
      }
    }, () => {
      if (this.editorRef.current) {
        this.editorRef.current.innerHTML = mail.body || "";
      }
    });
  };




  // 💾 SAVE MAIL
  handleSaveMail = () => {
    const { mailData, isEdit } = this.state;
    const body = this.editorRef.current?.innerHTML || "";

    const payload = {

      senderName: mailData.senderName,
      senderEmail: mailData.senderEmail,
      senderDesignation: mailData.senderDesignation,

      recipientName: mailData.recipientName,
      recipientEmail: mailData.recipientEmail,
      received: mailData.received,
      cc: mailData.cc,

      subject: mailData.subject,
      body
    };

    if (isEdit) {
      payload["id"] = mailData.id;
    }

    if (isEdit) {
      this.props.dispatch(dashboardActions.updateInsightMail(payload));
    } else {
      this.props.dispatch(dashboardActions.createInsightMail(payload));
    }

    this.props.dispatch(
      dashboardActions.saveInsightActivityTracking({
        activity: isEdit ? "Mail Updated" : "Mail Created"
      })
    );

    this.setState({ showMailForm: false });
  };






  saveEditInboxIntro = () => {
    const data = {
      inboxIntro: this.state.crrInboxIntro
    };
    this.props.dispatch(dashboardActions.saveInboxIntro(data));
    this.setState({ showInboxIntroEdit: false, crrInboxIntro: "" });
  };



  handleEditInboxIntro = (value) => {
    this.setState({ showInboxIntroEdit: true, crrInboxIntro: value });
  }


  handleInboxIntroChange = (value) => {
    // this.setState({ showInboxIntroEdit: value });
    this.setState({ crrInboxIntro: value });
  }


  exportPDFWithComponent = async () => {

    if (this.pdfExportComponent.current) {
      this.pdfExportComponent.current.save();
    }


  };



  render() {
    let { dashboard } = this.props;
    let { getInsightMailRepliesData: mailList = [] } = dashboard;

    return (
      <LayoutWrap>
        <div className="h-full flex bg-white">
          <div className="w-full mx-auto bg-white p-4 sm:p-6">

            {/* Header */}
            <div className="px-4 flex flex-col md:flex-row justify-between items-start md:items-center mb-5 gap-4">
              <h1 className="text-xl sm:text-2xl font-medium textblack">
                {/* All Mail Replies */}
              </h1>
              <div onClick={() => this.exportPDFWithComponent()}
                className="flex items-center py-3.5 px-4 text-sm border rounded-md cursor-pointer font-medium text-[#212121] md:w-auto w-full" >
                <span class="material-symbols-outlined mr-2">
                  file_download
                </span> Download PDF
              </div>
            </div>

            <div className="flex flex-1 overflow-hidden">


              <main className={`flex-1 flex flex-col bg-white overflow-y-auto ${!this.state.showMobileDetail ? 'hidden lg:flex' : 'flex'}`}>
                <div className="lg:col-span-4 h-screen pb-52 overflow-y-auto scrollbar p-4">
                  <PDFExport ref={this.pdfExportComponent}
                    pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
                    scale={0.6}
                    // forcePageBreak=".page-break"
                    paperSize="A4"
                    margin={0}
                    fileName={"All Mail Replies"}
                    author="Happyplus Team"
                    landscape={false}
                  >
                    <div className="text-3xl p-4 font-bold">All Mail Replies</div>
                    <div className=" p-4">
                      {mailList && mailList.length > 0 ?
                        mailList.map((ele, i) =>
                          <div className="border border-gray-500 border-b my-2 p-4">
                            <div className="text-2xl py-4 font-bold text-blue-800">Mail {i + 1}</div>

                            <p className="text-sm ">


                              <span className="font-bold">From: </span>
                              <span className="textblack">{ele.senderName}</span>
                              <span className="textblack">({ele.senderEmail})</span><br />

                              {ele && ele.senderDesignation &&
                                <>
                                  <span className="font-bold">Designation: </span>
                                  <span className="textblack">{ele.senderDesignation}</span>
                                </>
                              }<br />


                              <span className="font-bold">To: </span>
                              <span className="textblack">{ele.recipientName}</span>

                              {ele && ele.recipientEmail &&
                                <>
                                  <span className="textblack">({ele.recipientEmail})</span>
                                </>
                              }<br />

                              {ele && ele.cc &&
                                <>
                                  <span className="font-bold">CC: </span>
                                  <span className="textblack">{ele.cc}</span><br />
                                </>
                              }

                              {ele && ele.received &&
                                <>
                                  <span className="font-bold">Received: </span>
                                  <span className="textblack">{ele.received}</span><br />
                                </>
                              }
                              <span className="font-bold">Subject: </span>
                              <span className="textblack">{ele.subject}</span><br />

                              <span className="font-bold">Body: </span>
                              <div
                                className="mt-4"
                                dangerouslySetInnerHTML={{ __html: ele.body }}
                              />

                            </p>

                            <div className="py-4 font-bold text-blue-800">No of Replies: {ele && ele.replies.length > 0 ? ele.replies.length : 0}</div>
                            <div className="space-y-6 py-4">
                              {ele && ele.replies.length > 0 ?
                                ele.replies.map((reply) => (
                                  <div key={reply.id} className="relative border-b border-gray-300 pb-6 last:border-0">
                                    <div className="flex gap-4">
                                      <div className="flex-1 relative">
                                        <div className="flex justify-between">
                                          <div>
                                            <p className="text-sm font-bold textblack">Replied By: {reply.employeeId.name}</p>
                                            {/* <p className="text-sm text-indigo-600 pt-0.5">{reply.date} {reply.time} 25 April, 12:25 pm</p> */}
                                          </div>
                                        </div>

                                        {reply.body && (
                                          <div
                                            className="textblack text-sm"
                                            dangerouslySetInnerHTML={{ __html: reply.body }}
                                          />
                                        )}


                                      </div>
                                    </div>
                                  </div>
                                )) : null}
                            </div>
                          </div>
                        ) : null}
                    </div>

                  </PDFExport>
                </div>
              </main>



            </div>
          </div>   </div>
      </LayoutWrap>
    );
  }
}

export default connect((state) => ({
  dashboard: state.dashboard,
}))(Replies);